import React from "react";
import enhancedEffi from "../../assets/images/marketing-prof/enhnced-effi.svg";
import improvedLeadQuality from "../../assets/images/marketing-prof/imprvd-lead-quality.svg";
import greaterROI from "../../assets/images/marketing-prof/greaterRoi.svg";
import scalableCamp from "../../assets/images/marketing-prof/scalable-camp.svg";

const benefitsList = [
  {
    icon: enhancedEffi,
    title: "Enhanced Efficiency",
    desc: "Streamline your marketing processes with automation, freeing up more time for creative and strategic work.",
  },
  {
    icon: improvedLeadQuality,
    title: "Improved Lead Quality",
    desc: "Capture and nurture high-quality leads, ensuring that your sales team is only working with the most promising prospects.",
  },
  {
    icon: greaterROI,
    title: "Greater ROI",
    desc: "Optimize your marketing spend by focusing on strategies and channels that deliver the best results, all backed by data-driven insights.",
  },
  {
    icon: scalableCamp,
    title: "Scalable Campaigns",
    desc: "Easily scale your marketing efforts, whether you’re launching a small targeted campaign or a large, multi-channel initiative.",
  },
];

const Benefits = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-white">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Key Advantages
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Benefits for Marketing Professionals
          </h2>
        </div>

        {/* 2x2 Card Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
          {benefitsList.map((item, idx) => (
            <div
              key={idx}
              className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Ghost Watermark Icon */}
              <img
                src={item.icon}
                alt=""
                className="tw-absolute tw-bottom-[-16px] tw-right-[-16px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none"
              />

              {/* Icon container */}
              <div
                className="tw-w-14 tw-h-14 tw-rounded-2xl tw-border tw-border-solid tw-flex tw-items-center tw-justify-center tw-mb-6"
                style={{
                  backgroundColor: "#EEF2FF",
                  borderColor: "#C7D2FE",
                }}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="tw-w-7 tw-h-7 tw-object-contain"
                  loading="lazy"
                />
              </div>

              {/* Text */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Benefits;
